import usaj_ga from '../script/Analytics/usaj-analytics'
import "jquery-ui/ui/widgets/autocomplete"
//Provides Autocomplete functionality
var locationAC = $.widget("custom.locationAC", $.ui.autocomplete, {
    _create: function () {
        this._super();
        this.widget().menu("option", "items", "> :not(.ui-autocomplete-category)");
    },
    _renderMenu: function (ul, items) {
        ul.addClass("usajobs-search-location-autocomplete");
        var that = this,
            currentCategory = "",
            header = '<li class="ui-autocomplete-close-header">Close &nbsp;&nbsp;&times;</li>',
            $header = $(header),
            remoteEnabled = $("#nav-location").hasClass("remote-enabled");

        if (this.term.toLowerCase() == "remote" && remoteEnabled) {
            items.unshift({
                actualValue: true,
                parentName: "",
                label: "Only show remote jobs",
                type: "remote jobs",
                value: "Only show remote jobs"
            });
            items.unshift({
                actualValue: false,
                parentName: "",
                label: "Exclude remote jobs",
                type: "remote jobs",
                value: "Exclude remote jobs"
            });
        }

        $.each(items, function (index, item) {
            var li;
            if (item.type !== currentCategory) {
                ul.append('<li class="ui-autocomplete-category ' + item.type + ' ">' + item.type + '</li>');
                currentCategory = item.type;
            }
            li = that._renderItemData(ul, item);
            if (item.Type) {
                li.attr("aria-label", item.type + " : " + item.value);
            }
        });
    },
    _renderItem: function (ul, item) {
        return $("<li>")
        .addClass(item.type)
        .attr("data-value", item.value)
        .append($("<a>").html(item.label))
        .appendTo(ul);
    }
});

var keywordAC = $.widget("custom.keywordAC", $.ui.autocomplete, {
    _create: function () {
        this._super();
        this.widget().menu("option", "items", "> :not(.ui-autocomplete-category)");
    },
    _renderMenu: function (ul, items) {
        ul.addClass("usajobs-search-keyword-autocomplete");
        var that = this,
            currentCategory = "",
            header = '<li class="ui-autocomplete-close-header">Close &nbsp;&nbsp;&times;</li>',
            $header = $(header);

        $.each(items, function (index, item) {
            var li;
            if (item.type !== currentCategory) {
                ul.append('<li class="ui-autocomplete-category ' + item.type + ' ">' + item.type + '</li>');
                currentCategory = item.type;
            }
            li = that._renderItemData(ul, item);
            if (item.Type) {
                li.attr("aria-label", item.type + " : " + item.value);
            }
        });
    },
    _renderItem: function (ul, item) {
        return $("<li>")
        .addClass(item.type)
        .attr("data-value", item.value)
        .append($("<a>").html(item.label))
        .appendTo(ul);
    }
});

global.logLocationAC = function(selectedTerm) {
    if (usaj_ga) {
        usaj_ga.simple_log_event('Location-Auto-Complete', 'select', selectedTerm);
        sessionStorage.setItem('autocomplete', 'true');
    }
}

global.logKeywordAC = function(selectedTerm) {
    if (usaj_ga) {
        usaj_ga.simple_log_event('Keyword-Auto-Complete', 'select', selectedTerm);
        sessionStorage.setItem('autocomplete', 'true');
    }
}

function termHighlighter(s, t) {
    var matcher = new RegExp("(" + $.ui.autocomplete.escapeRegex(t) + ")", "ig");
    return s.replace(matcher, "<strong>$1</strong>");
}

function splitTermHighlighter(s, t) {
    var splitString = t.split(" ").sort(function (a, b) { return b.length - a.length; }),
        matcherString = "";

    for (var i = 0; i < splitString.length; i++) {
        if (splitString[i] !== "") {
            matcherString = matcherString + "(" + $.ui.autocomplete.escapeRegex(splitString[i]) + ")|";
        }
    }

    var matcher = new RegExp(matcherString, "ig");
    s = s.replace(matcher, "<strong>$&</strong>");

    return s;
}

global.usajSrcHighlighter = function (request, response) {
    $.ajax({
        url: usajobsConfig.DataHome + "api/Autocomplete/Location",
        dataType: "json",
        crossdomain: true,
        cache: true,
        data: { term: request.term },
        success: function (data) {
            var results = [];

            for (var key in data) {
                for (var i = 0; i < data[key].length; i++) {
                    var label = data[key][i].Name;
                    var code = data[key][i].Code;
                    var parentName = "";

                    var autocompleteItem = {
                        value: label,
                        label: splitTermHighlighter(label, request.term),
                        type: key,
                        actualValue: code,
                        parentName: parentName
                    };

                    results.push(autocompleteItem);
                }
            }

            response(results);
        },
        global: false
    });
};

global.keywordSrcHighlighter = function (request, response) {
    $.ajax({
        url: usajobsConfig.DataHome + "api/Autocomplete/Keyword",
        dataType: "json",
        crossdomain: true,
        cache: true,
        data: { term: request.term },
        success: function (data) {
            var results = [];
            for (var key in data) {
                for (var i = 0; i < data[key].length; i++) {
                    var label = data[key][i].Name;
                    var code = data[key][i].Code;
                    var parentName = "";

                    if (key === "series") {
                        label = code + " - " + data[key][i].Name;
                    } else if (key === "occupations") {
                        code = data[key][i].Name;
                    }

                    if (data[key][i].hasOwnProperty('Acronym') && data[key][i]["Acronym"] != "") {
                        label = label + " (" + data[key][i].Acronym.toUpperCase() + ")";
                    }

                    if (data[key][i].hasOwnProperty('ParentName')) {
                        label = label + " - " + data[key][i].ParentName;
                        parentName = data[key][i].ParentName;
                    }

                    var autocompleteItem = {
                        value: label,
                        label: splitTermHighlighter(label, request.term),
                        type: key,
                        actualValue: code,
                        parentName: parentName
                    };

                    results.push(autocompleteItem);
                }
            }

            response(results);
        },
        global: false
    });
};

global.occupationSrcHighlighter = function (request, response) {
    $.ajax({
        url: usajobsConfig.DataHome + "api/Autocomplete/Occupation",
        dataType: "json",
        crossdomain: true,
        cache: true,
        data: { term: request.term },
        success: function (data) {
            var results = [];
            for (var key in data) {
                for (var i = 0; i < data[key].length; i++) {
                    var label = data[key][i].Name;
                    var code = data[key][i].Code;

                    if (key === "occupations") {
                        code = data[key][i].Name;
                    }

                    var autocompleteItem = {
                        value: label,
                        label: splitTermHighlighter(label, request.term),
                        type: key,
                        actualValue: code
                    };

                    results.push(autocompleteItem);
                }
            }

            response(results);
        },
        global: false
    });
};

global.languageSrcHighlighter = function (request, response) {
    $.ajax({
        url: usajobsConfig.DataHome + "api/Autocomplete/Language",
        dataType: "json",
        crossdomain: true,
        cache: true,
        data: { term: request.term },
        success: function (data) {
            response(data.map(function (key) {
                return { value: key.Name, label: splitTermHighlighter(key.Name, request.term), type: "Languages", actualValue: key.Code };
            }));
        },
        global: false
    });
};

$(function () {
    initAutoComplete();
});

function initAutoComplete() {
    $(".usaj-autocomplete-default").locationAC({
        source: usajSrcHighlighter,
        minLength: 2,
        select: function (event, ui) {
            var selectedObj = ui.item;
            logLocationAC(selectedObj.value);
            if (selectedObj.type === "remote jobs") {
                var parameter = "rmi=" + selectedObj.actualValue
                window.location.href = buildSearchUrl(parameter);
            }
            $(".usaj-autocomplete-default").val(selectedObj.value);
            return false;
        },
        open: function () {
            $(this).removeClass("ui-corner-all").addClass("ui-corner-top");
            $("ul.ui-menu").width($(this).innerWidth());
        },
        close: function () {
            $(this).removeClass("ui-corner-top").addClass("ui-corner-all");
        }
    });

    $("#nav-keyword, #search-keyword").keywordAC({
        source: keywordSrcHighlighter,
        minLength: 2,
        select: function (event, ui) {
            var selectedObj = ui.item,
                parameter = "";

            switch (selectedObj.type) {
                case "series":
                    parameter = selectedObj.parentName !== "" ? `j=${selectedObj.actualValue}` : `jf=${selectedObj.actualValue}`;
                    break;
                case "agencies":
                    parameter = `a=${selectedObj.actualValue}`;
                    break;
                case "departments":
                    parameter = `d=${selectedObj.actualValue}`;
                    break;
                case "occupations":
                    parameter = `soc=${selectedObj.actualValue}`;
                    break;
                case "job titles":
                    parameter = `jt=${selectedObj.actualValue}`;
                    break;
            }

            logKeywordAC(selectedObj.value);
            window.location.href = buildSearchUrl(parameter);

            return false;
        },
        open: function () {
            $(this).removeClass("ui-corner-all").addClass("ui-corner-top");
            $("ul.ui-menu").width($(this).innerWidth());
        },
        close: function () {
            $(this).removeClass("ui-corner-top").addClass("ui-corner-all");
        }
    });
}

function buildSearchUrl(parameter) {
    var baseUrl = $("#baseUrl").val();
    var url = "/Search/Results?" + parameter;
    if (baseUrl !== null && baseUrl !== undefined && baseUrl) {
        url = baseUrl + url;
    }
    return url;
}
